import type { ColumnMap, PendingOperation } from '@v2/pages/planboard/components/Board/web/types';

// Keeps dragged cards at their optimistic position during Redux rebuilds (Phase 1 / refetch).
// Only the position (index) is preserved from local state — item data always comes from Redux.
export const preserveOptimisticPositions = (
  columnMap: ColumnMap,
  pendingOperationsRef: React.MutableRefObject<Map<number, PendingOperation>>,
  currentColumnMap: ColumnMap | undefined
): void => {
  if (pendingOperationsRef.current.size === 0 || !currentColumnMap) {
    return;
  }

  // Make items arrays mutable (they reference Redux state)
  for (const col of Object.values(columnMap)) {
    col.items = [...col.items];
  }

  pendingOperationsRef.current.forEach((_, opId) => {
    // Find where this op is in the current local state (optimistic position)
    let localColumnId: number | null = null;
    let localIndex: number | null = null;

    for (const [colId, col] of Object.entries(currentColumnMap)) {
      const idx = col.items.findIndex((item) => item.productionOperationId === opId);
      if (idx !== -1) {
        localColumnId = Number(colId);
        localIndex = idx;
        break;
      }
    }

    if (localColumnId === null || localIndex === null) return;

    // Find and remove from wherever Redux placed it in the new columnMap
    let reduxItem = null;
    for (const col of Object.values(columnMap)) {
      const idx = col.items.findIndex((item) => item.productionOperationId === opId);
      if (idx !== -1) {
        [reduxItem] = col.items.splice(idx, 1);
        break;
      }
    }

    if (!reduxItem) return;

    // Insert at the optimistic position in the target column
    const targetCol = columnMap[localColumnId];
    if (targetCol) {
      const insertAt = Math.min(localIndex, targetCol.items.length);
      targetCol.items.splice(insertAt, 0, reduxItem);
    }
  });
};
